function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1 14c-.256 0-.512-.098-.707-.293-.39-.39-.39-1.023 0-1.414L5.586 7 .293 1.707c-.39-.39-.39-1.023 0-1.414.391-.39 1.023-.39 1.414 0l6 6c.391.391.391 1.023 0 1.414l-6 6c-.195.195-.45.293-.707.293",
  transform: "translate(-16 -13) translate(4 1) translate(12 12) matrix(-1 0 0 1 8 5)"
}))))));

function SvgIconBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iY3VycmVudENvbG9yIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEgMTRjLS4yNTYgMC0uNTEyLS4wOTgtLjcwNy0uMjkzLS4zOS0uMzktLjM5LTEuMDIzIDAtMS40MTRMNS41ODYgNyAuMjkzIDEuNzA3Yy0uMzktLjM5LS4zOS0xLjAyMyAwLTEuNDE0LjM5MS0uMzkgMS4wMjMtLjM5IDEuNDE0IDBsNiA2Yy4zOTEuMzkxLjM5MSAxLjAyMyAwIDEuNDE0bC02IDZjLS4xOTUuMTk1LS40NS4yOTMtLjcwNy4yOTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNiAtMTMpIHRyYW5zbGF0ZSg0IDEpIHRyYW5zbGF0ZSgxMiAxMikgbWF0cml4KC0xIDAgMCAxIDggNSkiLz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };